import axiosInstance from "../interceptor";
import { ApiEndpoints } from "../../constants/api/student.api";

export const studentAPI = {
    createApplication: (data) => {
        return axiosInstance.post(ApiEndpoints.createApplication.url,data);
    },
    fetchApplication: ({official_email}) => {
        return axiosInstance.get(`${ApiEndpoints.fetchApplication.url}?official_email=${official_email}`);
    },
    updatePersonalDetails: (data) => {
        return axiosInstance.post(ApiEndpoints.updatePersonalDetails.url,data);
    },
    updateCourse: (data) => {
        return axiosInstance.post(ApiEndpoints.updateCourse.url,data);
    },
    updateQualification: (data) => {
        return axiosInstance.post(ApiEndpoints.updateQualification.url,data);
    },
    updateEvidence: (data) => {
        return axiosInstance.post(ApiEndpoints.updateEvidence.url,data);
    },
    updateFurtherDetails: (data) => {
        return axiosInstance.post(ApiEndpoints.updateFurtherDetails.url,data);
    },
    submitApplication: (data) => {
        return axiosInstance.post(ApiEndpoints.submitApplication.url,data);
    },
    submitConsent: (data) => {
        return axiosInstance.post(ApiEndpoints.submitConsent.url,data);
    },
    fetchPersonalDetails: (data) => {
        return axiosInstance.get(ApiEndpoints.fetchPersonalDetails.url,data);
    },
    fetchAllCourses: (data) => {
        return axiosInstance.get(ApiEndpoints.fetchAllCourses.url,data);
    },
    fetchStudentCourse: (data) => {
        return axiosInstance.get(ApiEndpoints.fetchStudentCourse.url,data);
    },
    fetchQualification: (data) => {
        return axiosInstance.get(ApiEndpoints.fetchQualification.url,data);
    },
    fetchFurtherDetails: (data) => {
        return axiosInstance.get(ApiEndpoints.fetchFurtherDetails.url,data);
    },
    deleteCourse: (data) => {
        return axiosInstance.post(ApiEndpoints.deleteCourse.url,data);
    },
    deleteQualification: (data) => {
        return axiosInstance.post(ApiEndpoints.deleteQualfication.url,data);
    },
    fetchStudentID: ({official_email}) => {
        return axiosInstance.get(`${ApiEndpoints.getStudentID.url}?official_email=${official_email}`);
    }
};